import { logInfo } from "./logger";

export const supportedLocales = [
  "cs",
  "da",
  "de",
  "en",
  "en-GB",
  "en-AU",
  "en-IN",
  "en-NZ",
  "en-US",
  "en-XA",
  "en-XB",
  "en-ZZ",
  "es",
  "fi",
  "fr",
  "hr",
  "hu",
  "it",
  "ja",
  "ko",
  "nb",
  "nl",
  "pl",
  "pt",
  "pt-BR",
  "ru",
  "sl",
  "sr",
  "sv",
  "th",
  "tr",
  "uk",
  "vi",
  "zh",
  "zh-TW",
];

export function getSupportedLocale(locale: string): string {
  const normalizedLocale = locale.replace("_", "-");

  if (supportedLocales.includes(normalizedLocale)) {
    return normalizedLocale;
  }

  if ((normalizedLocale.match(/-/g) ?? []).length > 1) {
    const secondHyphen = normalizedLocale.indexOf("-", 3);
    const localeWithoutVariant = normalizedLocale.substring(0, secondHyphen);
    if (supportedLocales.includes(localeWithoutVariant)) {
      logInfo(`Unable to find locale data for ${locale}, attempting to load ${localeWithoutVariant} fallback`);
      return localeWithoutVariant;
    }
  }

  const languageCode = normalizedLocale.substring(0, 2);
  if (supportedLocales.includes(languageCode)) {
    logInfo(`Unable to find locale data for ${locale}, attempting to load ${languageCode} fallback`);
    return languageCode;
  }

  logInfo(`Unable to find locale data for ${locale}, attempting to load English fallback`);
  return "en";
}
